
import React from 'react';
import { useTranslation } from 'react-i18next';

const EmptyPublishedState: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="bg-gray-50 border rounded-lg p-8 text-center">
      <h3 className="text-lg font-medium mb-2">{t('feed.noInterviews')}</h3>
      <p className="text-gray-500">{t('feed.noInterviews')}</p>
    </div>
  );
};

export default EmptyPublishedState;
